"use client";

import { useState } from "react";
import { handleMailingList } from "@/app/utils/handle-mailing-list";
import { handleWaitlist } from "@/app/utils/handle-waitlist";

function WaitlistInput() {
  const [email, setEmail] = useState("");
  const [isFocused, setIsFocused] = useState(false);

  return (
    <div id="mailing-list" className="w-full">
      <div className="w-full mx-auto flex justify-center items-center">
        <div className="relative w-full">
          <div className="relative bg-gradient-to-br from-slate-700 via-slate-900 to-slate-950 rounded-3xl shadow-2xl overflow-hidden">
            <div className="relative px-6 py-6 sm:px-6 sm:py-6">
              <div
                className={`flex flex-col gap-3 transition-all duration-300`}
              >
                <div className="relative">
                  <input
                    type="email"
                    placeholder="Email"
                    className="w-full px-6 py-4 bg-white border-2 border-gray-300 rounded-2xl text-gray-800 placeholder-gray-400 focus:outline-none focus:border-primary focus:ring-2 focus:ring-primary/20 transition-all duration-300 text-base sm:text-lg"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    onFocus={() => setIsFocused(true)}
                    onBlur={() => setIsFocused(false)}
                  />
                </div>

                <button
                  className="group w-full px-6 py-2.5 bg-primary hover:bg-secondary text-white font-medium rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 transform flex items-center justify-center gap-2 text-sm sm:text-base"
                  onClick={() => {
                    handleWaitlist(email, 32216);
                  }}
                >
                  <span>Join Waitlist</span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="group-hover:translate-x-1 transition-transform duration-300"
                  >
                    <path d="M5 12h14" />
                    <path d="m12 5 7 7-7 7" />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default WaitlistInput;
